import {
  Component,
  inject,
  OnInit,
  ChangeDetectorRef,
  HostListener,
  ElementRef,
} from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { Api } from '../../services/api';
import { AlertService } from '../../services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { jwtDecode } from 'jwt-decode';
import { forkJoin } from 'rxjs';
import { MdlNewTaskComponent } from '../../components/mdl-new-task/mdl-new-task';
import { MDLModifyTask } from '../../components/mdl-modify-task/mdl-modify-task';
import { MdlDeleteTask } from '../../components/mdl-delete-task/mdl-delete-task';
import { MdlChangeTaskOwner } from '../../components/mdl-change-task-owner/mdl-change-task-owner';
import { MdlChangestatuscomponent } from '../../components/mdl-change-taskStatus/mdl-change-taskStatus';
import { Mdlfilterectivities } from '../../components/mdl-filter-activities/mdl-filter-activities';
import { PermissionService } from '../../services/permission.service';
import { MdlNewEventComponent } from '../../components/mdl-new-event/mdl-new-event';

@Component({
  selector: 'app-task',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
  ],
  templateUrl: './task.html',
  styleUrls: ['./task.css'],
})
export class Task implements OnInit {
  tareas: any[] = [];
  tareasFiltradas: any[] = [];
  isLoading: boolean = true;
  errorMessage: string = '';
  showRecentDropdown: boolean = false;
  openedMenuId: string | null = null;
  selectedItem: string = 'todas';
  tareasSeleccionadas = 0;
  showActionsDropdown = false;
  selectedTask: string[] = [];
  readonly dialog = inject(MatDialog);


  searchTerm: string = '';
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  activeFilters: any = null;

  ngOnInit(): void {
    this.cargatareas();
    this.initializeFilters();
  }

  constructor(
    private api: Api,
    private elementRef: ElementRef,
    private router: Router,
    private alertService: AlertService,
    private cdRef: ChangeDetectorRef,
    public permissionService: PermissionService,
    
  ) {}



  private initializeFilters(): void {
  if (!this.activeFilters) {
    this.activeFilters = {
      dateRange: 'all',
      activityView: 'all',
      allTypes: true,
      allStatuses: true,
      types: {
        email: false,
        listEmail: false,
        calls: false,
        tasks: false,
        events: false
      },
      statuses: {
        pendiente: false,
        enProgreso: false,
        completada: false,
        vencida: false,
        programada: false,
        cancelada: false
      }
    };
  }
}




  onSearchChange(): void {
    if (!this.searchTerm.trim()) {
      this.filterTasks();
    } else {
      const searchLower = this.searchTerm.toLowerCase().trim();
      this.tareasFiltradas = this.tareas.filter(tarea => 
        tarea.titulo?.toLowerCase().includes(searchLower) ||
        tarea.descripcion?.toLowerCase().includes(searchLower) ||
        tarea.tipo?.toLowerCase().includes(searchLower) ||
        tarea.estado?.toLowerCase().includes(searchLower) ||
        tarea.prioridad?.toLowerCase().includes(searchLower) ||
        tarea.ejecutivo?.nombre?.toLowerCase().includes(searchLower) ||
        tarea.ejecutivo?.apellido?.toLowerCase().includes(searchLower)
      );
    }
    
    if (this.sortColumn) {
      this.applySorting();
    }
  }

  actualizarTabla(): void {
    this.cargatareas();
    this.alertService.success('Actualizado', 'Tabla actualizada');
  }

  editarTarea(): void {
    if (this.selectedTask.length === 0) {
      this.alertService.warning('Selección requerida', 'Por favor, selecciona una tarea para editar');
      return;
    }

    if (this.selectedTask.length > 1) {
      this.alertService.warning('Selección múltiple', 'Solo puedes editar una tarea a la vez');
      return;
    }

    const tareaId = this.selectedTask[0];
    const tarea = this.tareas.find(t => t.tarea_id === tareaId);
    
    if (tarea) {
      this.openMdlModifyTask(tarea);
    }
  }

  sortByColumn(column: string): void {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.applySorting();
  }

  private applySorting(): void {
    if (!this.sortColumn) return;

    this.tareasFiltradas = [...this.tareasFiltradas].sort((a, b) => {
      let valueA = a[this.sortColumn];
      let valueB = b[this.sortColumn];

      switch (this.sortColumn) {
        case 'fecha_creacion':
        case 'fecha_vencimiento':
          valueA = new Date(valueA || 0);
          valueB = new Date(valueB || 0);
          break;
        
        case 'estado':
          const priorityA = this.getEstadoPriority(valueA);
          const priorityB = this.getEstadoPriority(valueB);
          return this.sortDirection === 'asc' 
            ? priorityA - priorityB 
            : priorityB - priorityA;
        
        case 'prioridad':
          const prioridadA = this.getPrioridadPriority(valueA);
          const prioridadB = this.getPrioridadPriority(valueB);
          return this.sortDirection === 'asc' 
            ? prioridadA - prioridadB 
            : prioridadB - prioridadA;
        
        default:
          if (typeof valueA === 'string') {
            valueA = valueA.toLowerCase();
            valueB = valueB.toLowerCase();
          }
      }

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      }
      if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  private getEstadoPriority(estado: string): number {
    switch (estado?.toLowerCase()) {
      case 'vencida':
        return 5;
      case 'pendiente':
        return 4;
      case 'en progreso':
        return 3;
      case 'programada':
        return 2;
      case 'completada':
      case 'realizada':
        return 1;
      case 'cancelada':
        return 0;
      default:
        return -1;
    }
  }

  private getPrioridadPriority(prioridad: string): number {
    switch (prioridad?.toLowerCase()) {
      case 'alta':
        return 3;
      case 'media':
        return 2;
      case 'baja':
        return 1;
      default:
        return 0;
    }
  }

  openFilterModal(): void {
    const dialogRef = this.dialog.open(Mdlfilterectivities, {
      minWidth: '600px',
      maxHeight: '80vh',
      panelClass: 'mat-dlg-class',
      data: this.activeFilters 
    });

    dialogRef.afterClosed().subscribe((filters: any) => {
      if (filters) {
        this.activeFilters = filters;
        this.applyAdvancedFilters();
        this.alertService.success('Filtros aplicados', 'Filtros aplicados correctamente');
      }
    });
  }

  private applyAdvancedFilters(): void {
      console.log('🔍 Aplicando filtros avanzados:', this.activeFilters);

  if (!this.activeFilters) {
    this.filterTasks();
    return;
  }

  let filteredTasks = [...this.tareas];
  console.log('📊 Tareas antes de filtrar:', filteredTasks.length);

  if (this.activeFilters.dateRange) {
    filteredTasks = this.filterByDateRange(filteredTasks, this.activeFilters.dateRange);
  }

  if (this.activeFilters.activityView === 'mine') {
    const token = localStorage.getItem('crmtoken');
    if (token) {
      const decoded: any = jwtDecode(token);
      const userID = decoded.userId;
      filteredTasks = filteredTasks.filter(t => t.ejecutivo_id === userID);
    }
  }

  if (!this.activeFilters.allTypes) {
    const selectedTypes = Object.keys(this.activeFilters.types).filter(key => this.activeFilters.types[key]);
    if (selectedTypes.length > 0) {
      filteredTasks = filteredTasks.filter(tarea => {
        const taskType = this.mapTaskTypeToFilter(tarea.tipo);
        return selectedTypes.includes(taskType);
      });
    }
  }

  if (!this.activeFilters.allStatuses) {
    const selectedStatuses = Object.keys(this.activeFilters.statuses).filter(key => this.activeFilters.statuses[key]);
    if (selectedStatuses.length > 0) {
      filteredTasks = filteredTasks.filter(tarea => {
        const taskStatus = this.mapTaskStatusToFilter(tarea.estado);
        return selectedStatuses.includes(taskStatus);
      });
    }
  }

  this.tareasFiltradas = filteredTasks;
  
  if (this.sortColumn) {
    this.applySorting();
  }
  console.log('📊 Tareas después de filtrar:', this.tareasFiltradas.length);
  console.log('🔍 Tareas filtradas:', this.tareasFiltradas);
}

private mapTaskStatusToFilter(estadoTarea: string): string {
  const statusMap: { [key: string]: string } = {
    'pendiente': 'pendiente',
    'en progreso': 'enProgreso',
    'completada': 'completada',
    'vencida': 'vencida',
    'programada': 'programada',
    'cancelada': 'cancelada',
    'realizada': 'completada' 
  };
  
  return statusMap[estadoTarea?.toLowerCase()] || estadoTarea?.toLowerCase();
}


  private filterByDateRange(tasks: any[], dateRange: string): any[] {
    const hoy = new Date();
    
    switch (dateRange) {
      case '2m':
        const dosMesesAtras = new Date(hoy);
        dosMesesAtras.setMonth(hoy.getMonth() - 2);
        return tasks.filter(t => new Date(t.fecha_creacion) >= dosMesesAtras);
      
      case '30d':
        const treintaDiasAtras = new Date(hoy);
        treintaDiasAtras.setDate(hoy.getDate() - 30);
        return tasks.filter(t => new Date(t.fecha_creacion) >= treintaDiasAtras);
      
      case '7d-next':
        const sieteDiasAdelante = new Date(hoy);
        sieteDiasAdelante.setDate(hoy.getDate() + 7);
        return tasks.filter(t => new Date(t.fecha_vencimiento) <= sieteDiasAdelante && new Date(t.fecha_vencimiento) >= hoy);
      
      case '6m':
        const seisMesesAtras = new Date(hoy);
        seisMesesAtras.setMonth(hoy.getMonth() - 6);
        return tasks.filter(t => new Date(t.fecha_creacion) >= seisMesesAtras);
      
      case '7d':
        const sieteDiasAtras = new Date(hoy);
        sieteDiasAtras.setDate(hoy.getDate() - 7);
        return tasks.filter(t => new Date(t.fecha_creacion) >= sieteDiasAtras);
      
      case 'all':
      default:
        return tasks;
    }
  }

  private mapTaskTypeToFilter(tipoTarea: string): string {
  const typeMap: { [key: string]: string } = {
    'email': 'email',
    'correo': 'email',
    'correos de lista': 'listEmail',
    'llamada': 'calls',
    'call': 'calls',
    'llamadas registradas': 'calls',
    'tarea': 'tasks',
    'task': 'tasks',
    'evento': 'events',
    'event': 'events'
  };
  
  return typeMap[tipoTarea?.toLowerCase()] || 'tasks';
}
  hasActiveFilters(): boolean {
  if (!this.activeFilters) return false;
  const hasDateFilter = this.activeFilters.dateRange !== '2m';
  const hasActivityFilter = this.activeFilters.activityView !== 'all';
  const hasTypeFilter = !this.activeFilters.allTypes && 
    Object.values(this.activeFilters.types).some(val => val === true);
  const hasStatusFilter = !this.activeFilters.allStatuses && 
    Object.values(this.activeFilters.statuses).some(val => val === true);
  return hasDateFilter || hasActivityFilter || hasTypeFilter || hasStatusFilter;
}

  clearFilters(): void {
    this.activeFilters = null;
    this.searchTerm = '';
    this.sortColumn = '';
    this.sortDirection = 'asc';
    this.filterTasks();
    this.alertService.success('Filtros limpiados', 'Los filtros han sido limpiados');
  }

  cargatareas() {
    this.api.showLoading();
    this.isLoading = true;
    this.errorMessage = '';

    this.api.getTasks().subscribe({
      next: (response: any) => {
        this.tareas = (response.tareas || response).map((tarea: any) => ({
          ...tarea,
          id: tarea.tarea_id || tarea.id,
        }));

        if (this.activeFilters) {
          this.applyAdvancedFilters();
        } else {
          this.filterTasks();
        }
        
        this.searchTerm = '';

        setTimeout(() => {
          this.api.hideLoading();
          this.isLoading = false;
          this.cdRef.detectChanges();
        }, 500);
      },
      error: (error: any) => {
        console.error('Error al cargar tareas:', error);
        this.api.hideLoading();
        this.isLoading = false;
        this.errorMessage = 'Error al cargar las tareas';
      },
    });
  }

  filterTasks(): void {
    const hoy = new Date();

    switch (this.selectedItem) {
      case 'todas':
        this.tareasFiltradas = [...this.tareas];
        break;

      case 'delDia':
        const hoyStr = hoy.toISOString().split('T')[0];
        this.tareasFiltradas = this.tareas.filter((t) => {
          const fechaStr = t.fecha_vencimiento;
          return fechaStr === hoyStr;
        });
        break;

      case 'progreso':
        this.tareasFiltradas = this.tareas.filter(
          (t) => t.estado === 'En progreso'
        );
        break;

      case 'atrasadas':
        this.tareasFiltradas = this.tareas.filter(
          (t) =>
            new Date(t.fecha_vencimiento) < hoy && t.estado !== 'Completada'
        );
        break;

      case 'proximas':
        this.tareasFiltradas = this.tareas.filter((t) => {
          const fechaFin = new Date(t.fecha_vencimiento);
          const diffTime =
            (fechaFin.getTime() - hoy.getTime()) / (1000 * 60 * 60 * 24);
          return diffTime >= 0 && diffTime <= 7;
        });
        break;
      case 'propias':
        const token = localStorage.getItem('crmtoken');
        if (!token) {
          this.tareasFiltradas = [];
          break;
        }
        const decoded: any = jwtDecode(token);
        const userID = decoded.userId;
        this.tareasFiltradas = this.tareas.filter(
          (t) => t.ejecutivo_id === userID
        );
        break;
    }

    if (this.searchTerm.trim()) {
      this.onSearchChange();
    }

    if (this.sortColumn) {
      this.applySorting();
    }
  }

  toggleActionsMenu(id: string): void {
    this.openedMenuId = this.openedMenuId === id ? null : id;
    this.showRecentDropdown = false;
  }

  toggleRecentDropdown(): void {
    this.showRecentDropdown = !this.showRecentDropdown;
  }

  selectItem(key: string): void {
    this.selectedItem = key;
    if (this.activeFilters) {
      this.applyAdvancedFilters();
    } else {
      this.filterTasks();
    }
    this.showRecentDropdown = false;
  }

  toggleActionsDropdown() {
    this.showActionsDropdown = !this.showActionsDropdown;
  }

  getTaskIcon(tipo: string): string {
    if (!tipo) return 'assets/svg/default-task-icon.svg';

    switch (tipo.toLowerCase()) {
      case 'tarea':
        return 'assets/svg/task-table-icon.svg';
      case 'evento':
        return 'assets/svg/event-task-icon.svg';
      case 'llamada':
        return 'assets/svg/call-task-icon.svg';
      case 'email':
        return 'assets/svg/mail-task-icon.svg';
      case 'modificar':
        return 'assets/svg/modify-task-icon.svg';
      default:
        return 'assets/svg/default-task-icon.svg';
    }
  }

  getNombreRelacionado(tarea: any): string {
    if (!tarea.asociado_tipo || tarea.asociado_tipo === 'OTRO') {
      return 'Sin relación específica';
    }

    switch (tarea.asociado_tipo) {
      case 'CNT':
        return `Contacto: ${tarea.asociado?.nombre || ''} ${
          tarea.asociado?.apellido || ''
        }`;

      case 'ACC':
        return `Cuenta: ${tarea.asociado?.nombre_empresa || ''}`;

      case 'OPP':
        return `Oportunidad: ${tarea.asociado?.nombre || ''}`;

      default:
        return 'Relación no especificada';
    }
  }

  onCheckboxChange(event: any, taskId: string) {
    if (event.target.checked) {
      this.selectedTask.push(taskId);
    } else {
      this.selectedTask = this.selectedTask.filter((id) => id !== taskId);
    }

    this.tareasSeleccionadas = this.selectedTask.length;
  }

  completarTareasSeleccionadas(): void {
    if (this.selectedTask.length === 0) {
      this.alertService.warning('Selección requerida', 'No hay tareas seleccionadas');
      return;
    }

    this.api.showLoading();

    const updates = this.selectedTask.map((taskId) =>
      this.api.updateTaskStatus({
        tarea_id: taskId,
        estado: 'Completada',
      })
    );

    forkJoin(updates).subscribe({
      next: (results) => {
        setTimeout(() => {
          this.api.hideLoading();
          this.cargatareas();
          this.selectedTask = [];
          this.tareasSeleccionadas = 0;
          this.alertService.success(
            'Tareas completadas',
            `${results.length} tareas completadas exitosamente`
          );
        }, 500);
      },
      error: (error) => {
        console.error('Error completando tareas:', error);
        this.api.hideLoading();
        this.alertService.error('Error al completar', 'Error al completar las tareas');
      },
    });
  }

  cambiarPropietarioTareas(): void {
    if (this.selectedTask.length === 0) {
      this.alertService.warning('Selección requerida', 'No hay tareas seleccionadas');
      return;
    }

    this.dialog
      .open(MdlChangeTaskOwner, {
        minWidth: '500px',
        maxHeight: '400px',
        panelClass: 'mat-dlg-class',
        data: {
          mode: this.selectedTask.length > 1 ? 'multiple' : 'single',
          taskIds: this.selectedTask,
          taskId: this.selectedTask.length === 1 ? this.selectedTask[0] : null,
          count: this.selectedTask.length,
        },
      })
      .afterClosed()
      .subscribe((result) => {
        console.log('Resultado del cambio de propietario:', result);

        if (result && result.success) {
          this.cargatareas();
          this.selectedTask = [];
          this.tareasSeleccionadas = 0;

          this.alertService.success('Propietario cambiado', result.message);
        } else if (result && !result.success) {
          this.alertService.error(
            'Error al cambiar propietario',
            result.message || 'Error al cambiar propietario'
          );
        }
      });
  }

  cambiarPropietarioIndividual(tarea: any): void {
    this.openedMenuId = null;

    this.dialog
      .open(MdlChangeTaskOwner, {
        minWidth: '500px',
        maxHeight: '400px',
        panelClass: 'mat-dlg-class',
        data: {
          mode: 'single',
          taskId: tarea.tarea_id,
          count: 1,
        },
      })
      .afterClosed()
      .subscribe((result) => {
        if (result && result.success) {
          this.cargatareas();
          this.alertService.success('Propietario cambiado', 'Propietario cambiado exitosamente');
        }
      });
  }

  ejecutarAccion(accion: string) {
    switch (accion) {
      case 'eliminar':
        if (this.selectedTask.length > 0) {
          const taskCount = this.selectedTask.length;

          this.dialog
            .open(MdlDeleteTask, {
              minWidth: '500px',
              maxHeight: '300px',
              panelClass: 'mat-dlg-class',
              data: {
                mode: 'multiple_tasks',
                ids: this.selectedTask,
                count: this.selectedTask.length,
              },
            })
            .afterClosed()
            .subscribe((result) => {
              if (result) {
                this.cargatareas();
                this.selectedTask = [];
                this.tareasSeleccionadas = 0;
                this.alertService.success(
                  'Tareas eliminadas',
                  `${taskCount} tareas eliminadas exitosamente`
                );
              }
            });
        }
        break;

      case 'completar':
        this.completarTareasSeleccionadas();
        break;

      case 'cambiar':
        this.cambiarPropietarioTareas();
        break;
    }
  }

openMdlModifyTask(tarea: any): void {
  this.openedMenuId = null;

  const tipo = (tarea.tipo || '').toLowerCase();

  if (tipo === 'evento') {
    this.dialog
      .open(MdlNewEventComponent, {
        minWidth: '800px',
        maxHeight: '90vh',
        panelClass: 'mat-dlg-class',
        data: {
          mode: 'edit',
          existingTask: tarea,
        },
      })
      .afterClosed()
      .subscribe((result) => {
        if (result && result.success) {
          this.cargatareas();
          this.alertService.success(
            'Evento modificado',
            'Evento modificado exitosamente'
          );
        }
      });
  } else {
    this.dialog
      .open(MdlNewTaskComponent, {
        minWidth: '800px',
        maxHeight: '90vh',
        panelClass: 'mat-dlg-class',
        data: {
          existingTask: tarea,
          mode: 'edit',
          task: tarea,
        },
      })
      .afterClosed()
      .subscribe((result) => {
        if (result && result.success) {
          this.cargatareas();
          this.alertService.success(
            'Tarea modificada',
            'Tarea modificada exitosamente'
          );
        }
      });
  }
}


  openMdlNewTask(): void {
    this.dialog.open(MdlNewTaskComponent, {
      minWidth: '500px',
      maxHeight: '600px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'crear',
      },
    }).afterClosed().subscribe((result) => {
    console.log('Resultado creación tarea:', result);
    if (result && result.success) {
      this.selectedTask = [];
      this.tareasSeleccionadas = 0;
      this.cargatareas();
      this.alertService.success(
        'Éxito',
        'La tarea fue creada con éxito'
      );
    }
    else if (result && result.success === false) {
      this.alertService.error(
        'Error al crear tarea',
        'Ocurrió un problema al crear la tarea'
      );
    }
  });
}

  openMdlDeleteTask(tarea: any): void {
    this.openedMenuId = null;

    console.log('Abriendo modal para eliminar tarea:', tarea.tarea_id);

    this.dialog
      .open(MdlDeleteTask, {
        minWidth: '500px',
        maxHeight: '300px',
        panelClass: 'mat-dlg-class',
        data: {
          mode: 'task',
          id: tarea.tarea_id,
          tarea: tarea,
        },
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          console.log('Tarea eliminada, recargando lista...');
          this.cargatareas();

          this.alertService.success('Tarea eliminada', 'Tarea eliminada exitosamente');
        }
      });
  }

  openmdlchangeStatus(tarea: any) {
    this.dialog.open(MdlChangestatuscomponent, {
      minWidth: '500px',
      maxHeight: '330px',
      panelClass: 'mat-dlg-class',
      data: {
        tarea_id: tarea.tarea_id,
        mode: 'estado',
      },
    }).afterClosed().subscribe(result => {
    if (result) {
      this.cargatareas(); 
    }
  });
}

  openmdlchangePriority(tarea: any) {
    this.dialog.open(MdlChangestatuscomponent, {
      minWidth: '500px',
      maxHeight: '330px',
      panelClass: 'mat-dlg-class',
      data: {
        tarea_id: tarea.tarea_id,
        mode: 'prioridad',
      },
    }).afterClosed().subscribe(result => {
    if (result) {
      this.cargatareas(); 
    }
  });
}

  private esUUIDValido(id: string): boolean {
    const uuidRegex =
      /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return uuidRegex.test(id);
  }

  @HostListener('document:click', ['$event.target'])
  onClickOutside(target: EventTarget | null): void {
    if (!(target instanceof HTMLElement)) return;

    const clickedInsideRecent = this.elementRef.nativeElement
      .querySelector('.dropdown-trigger')
      ?.contains(target);
    const clickedInsideActions = this.elementRef.nativeElement
      .querySelector('.dots-button')
      ?.contains(target);

    if (!clickedInsideRecent) {
      this.showRecentDropdown = false;
    }

    if (!clickedInsideActions) {
      this.openedMenuId = null;
    }
  }

  verDetalleTarea(id: string, event?: MouseEvent): void {
    if (event) {
      const target = event.target as HTMLElement;
      const isCheckbox =
        target.tagName === 'INPUT' &&
        target.getAttribute('type') === 'checkbox';
      const isDropdown = target.closest('.dropdown-container') !== null;

      if (isCheckbox || isDropdown) {
        return;
      }
    }

    if (!id || !this.esUUIDValido(id)) {
      this.alertService.error('ID inválido', 'ID de tarea no válido');
      return;
    }

    this.router.navigate(['task', id]).then((navigationResult) => {
      if (!navigationResult) {
        this.alertService.error(
          'Error de navegación',
          'No se pudo cargar el detalle de la tarea'
        );
        console.error('Error de navegación a task/', id);
      }
    });
  }
}
